import vue from '@/main'

import user from "@/http/requests/user"

import store from "@/store/store.js"

export default {
  fetch({ commit }) {
    return new Promise((resolve, reject) => {
      user.fetch().then(response => {
        commit('SET_USERS', response.data.data.users)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  add({ commit }, data) {
    return new Promise((resolve, reject) => {
      user.add(data).then(response => {
        commit('ADD_USER', response.data.data.createUser.user)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  update({ commit }, data) {
    return new Promise((resolve, reject) => {
      user.update(data).then(response => {
        commit('UPDATE_USER', response.data.data.updateUser.user)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  delete({ commit }, userId) {
    return new Promise((resolve, reject) => {
      user.delete(userId).then(response => {
        commit('DELETE_USER', userId)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  infos({ commit }) {
    return new Promise((resolve, reject) => {
      user.infos().then(response => {
        commit('ADD_USER_INFOS', response.data.data.userInfos.user)
        resolve(response)
      })
      .catch((error) => { reject(error) })
    })
  },
  backToOriginalUser(originalUser) {
    return new Promise((resolve) => {
      store.commit("auth/SET_BEARER", originalUser.originalBearer)
      store.commit('UPDATE_USER_INFO', originalUser)

      vue.$router.push({ path: '/' })

      resolve(originalUser)
    })
  }
}
